/*eslint @typescript-eslint/no-unused-vars: "off"*/
/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { Base } from "./Base";

/**
 * 
 * @export
 * @interface Tag
 */
export interface Tag {
    /**
     * When was the entity created
     * @type {Date}
     * @memberof Tag
     */
    created_at: Date;
    /**
     * When was the entity updated
     * @type {Date}
     * @memberof Tag
     */
    updated_at: Date;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    owner_id: string;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    tag_type: TagTagTypeEnum;
}




/**
* @export
* @enum {string}
*/
export enum TagTagTypeEnum {
    NORMAL = 'NORMAL',
    VENDOR = 'VENDOR',
    VRM = 'VRM'
}


